/* eslint-disable */
import React from 'react';
import { Box, Typography } from '@mui/material';

const OPTIONS = [10, 25, 50, 100];

/**
 * PerPageSelector — Vercel-style inline per-page toggle.
 * Renders as small pill buttons showing 10 | 25 | 50 | 100.
 */
function PerPageSelector({ value, onChange }) {
    return (
        <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.75 }}>
            <Typography sx={{ fontSize: '11.5px', fontWeight: 500, color: '#94A3B8', whiteSpace: 'nowrap' }}>
                Rows:
            </Typography>
            <Box
                sx={{
                    display: 'inline-flex',
                    borderRadius: '8px',
                    border: '1px solid rgba(15, 23, 42, 0.06)',
                    background: 'rgba(255, 255, 255, 0.6)',
                    backdropFilter: 'blur(6px)',
                    overflow: 'hidden'
                }}
            >
                {OPTIONS.map((opt) => (
                    <Box
                        key={opt}
                        component="button"
                        onClick={() => onChange(opt)}
                        sx={{
                            px: 1.25,
                            py: 0.5,
                            border: 'none',
                            borderRight: '1px solid rgba(15, 23, 42, 0.04)',
                            background: value === opt ? 'rgba(99, 102, 241, 0.08)' : 'transparent',
                            cursor: 'pointer',
                            fontFamily: 'inherit',
                            outline: 'none',
                            transition: 'all 150ms ease',
                            '&:last-child': { borderRight: 'none' },
                            '&:hover': { background: value === opt ? 'rgba(99, 102, 241, 0.12)' : 'rgba(241, 245, 249, 0.8)' },
                            '&:focus-visible': { outline: '2px solid #4F46E5', outlineOffset: '-2px', zIndex: 1 }
                        }}
                    >
                        <Typography
                            component="span"
                            sx={{
                                fontSize: '11.5px',
                                fontWeight: value === opt ? 700 : 500,
                                color: value === opt ? '#4F46E5' : '#64748B'
                            }}
                        >
                            {opt}
                        </Typography>
                    </Box>
                ))}
            </Box>
        </Box>
    );
}

export default PerPageSelector;
